/* @ngInject */
function dateMediumFilter ($filter) {
  return function (date) {
    if (!date) {
      return ''
    }
    const newDate = moment(date)
    const dayWeek = newDate.format('ddd')
    const fullDate = newDate.format('DD MMM YYYY')
    return dayWeek + ', ' + fullDate
  }
}

export { dateMediumFilter }
